var canvas, canvas2,text,fontSize, fontFamily, fSize, activeCOLOR, newText, zoom, cWidth = 1400, cHeight = 2000,
    halfWidth = cWidth / 2, halfHeight = cHeight / 2,
    obj, array = [], get_data, sizeCrop,
    scale_factor, newheight, leftOb, imageUrl,img,newImg,
    placeholderimg1, leftMarker, rightMarker, vLine;

var loader = jQuery('#customLoader'),
    cropper = "", canvas, boxWidth, boxLeft, boxTop,
    croppedSize, orientations, aspectRatio, reCroper,
    c1img1;

var sizeB1W = 877, sizeB1H = 1220;

imageUrl = document.getElementById('imageContainer').getAttribute('data-image-url');



window['canvas2'] = new fabric.Canvas('canvas2', {
  width: cWidth,
  height: cHeight
});

addModify(window['canvas2']);



$(document).ready(function() {

  baseImage = null; 

  function loadImage(url) {
    if (baseImage) {
      canvas2.remove(baseImage);
    }
    fabric.Image.fromURL(url, function(img) {
      img.set({
        left: halfWidth,
        top: halfHeight,
        selectable: false
      });
      // img.scale(.6);
      canvas2.add(img);
      baseImage = img; 
      img.sendToBack();
      // window['text1Page'].bringToFront();
      canvas2.renderAll();
    }, { crossOrigin: 'anonymous' });
  }

  var defaultUrl = $('#base1 img').attr('data-src');
  if(defaultUrl) {
    loadImage(defaultUrl);
  }

  
  // On style change
  jQuery(document).on('change', 'input[name="Style"]', function(e) {
    var selectedVal = $(this).val();

    if (selectedVal === 'Without Base (Height 9 Width 6 inches)') {
      var blackUrl = $('#base1 img').attr('data-src');
      loadImage(blackUrl);
    } else {
      var woodenUrl = $('#base2 img').attr('data-src');
      loadImage(woodenUrl);
    }
  });

});


window['placeholderimg1'] = new fabric.Rect({
  left: halfWidth,
  top: 940,
  width: sizeB1W,
  height: sizeB1H,
  fill: 'rgba(0,0,0,0.1)'
});

window['canvas2'].add(window['placeholderimg1']);

document.getElementById('image_upload_first').addEventListener('change',function(e){
  canvas = window['canvas2'];
  available_height = sizeB1H;
  img = window['placeholderimg1'];
  sizeCrop = '0.72';
  reCroper = jQuery(this).parent().next().find('.btnReCrop').attr('data-height',available_height);
  readURL2(e.target);
});




const areaWidth = 1000;
const gapDefault = 6;
const tileMax = 120;
const tileMin = 20;

let textureImg = null;
let crosswordGroup = null;
let nameText = "";


// helper: normalize & validate incoming name string
function normalizeName(raw) {
  if (!raw) return "";
  // uppercase, trim edges, collapse multiple spaces to single
  let s = raw.toUpperCase().trim().replace(/\s+/g, ' ');
  return s;
}

function isNameValid(name) {
  // allow letters A-Z and spaces only, and require at least one letter
  if (!name) return false;
  if (!/^[A-Z ]+$/.test(name)) return false;      // only A-Z and spaces
  if (!/[A-Z]/.test(name)) return false;          // at least one letter
  return true;
}


// ✅ Initialize Texture
$(document).ready(function () {
  const defaultUrl = $('#shape_design a').first().find('img').attr('data-src');
  if (defaultUrl) {
    $('#shape_design img').first().addClass('active');
    setTexture(defaultUrl);
  }
});

// ✅ Handle Texture Change
$('#shape_design a').on('click', function (e) {
  e.preventDefault();
  const url = $(this).find('img').attr('data-src');
  $('#shape_design img').removeClass('active');
  $(this).find('img').addClass('active');
  setTexture(url);
});

// ✅ Load Texture
function setTexture(url) {
  fabric.Image.fromURL(
    url,
    function (img) {
      textureImg = img;

      // ✅ If crosswordGroup already exists — update all rects’ fills
      if (crosswordGroup && crosswordGroup._objects) {
        crosswordGroup._objects.forEach(obj => {
          if (obj.type === 'rect') {
            if (textureImg) {
              const tile = obj.width;
              const patternCanvas = document.createElement('canvas');
              patternCanvas.width = tile;
              patternCanvas.height = tile;
              const ctx = patternCanvas.getContext('2d');
              ctx.drawImage(
                textureImg.getElement(),
                0, 0,
                textureImg.getElement().naturalWidth || textureImg.width,
                textureImg.getElement().naturalHeight || textureImg.height,
                0, 0, tile, tile
              );
              obj.set('fill', new fabric.Pattern({ source: patternCanvas, repeat: 'no-repeat' }));
            } else {
              obj.set('fill', '#f7e2b0');
            }
          }
        });
        canvas2.renderAll();
      }
    },
    { crossOrigin: 'anonymous' }
  );
}


// ✅ Handle name input
const input = document.getElementById("nameInput");
const errorMsg = document.getElementById("errorMsg");
const nameCount = document.getElementById("nameCount");


window.addEventListener("load", function () {
  const dummyName = "ENTER NAME";
  input.value = dummyName;
  nameText = normalizeName(dummyName);
  nameCount.innerText = "1/1";

  // ✅ Load font first, then render once
  Promise.all([
    document.fonts.load('400 16px "Markazi Text"'),
    document.fonts.load('700 16px "Markazi Text"'),
    document.fonts.ready
  ])
    .then(() => {
      renderNameScrabble();
      setTimeout(() => renderNameScrabble(), 200);
    })
    .catch(() => {
      setTimeout(() => renderNameScrabble(), 500);
    });

  // ✅ Remove dummy text when user focuses the input
  input.addEventListener("focus", function () {
    if (input.value.trim().toUpperCase() === dummyName) {
      input.value = "";
      nameText = "";
      nameCount.innerText = "0/1";
      canvas2.remove(crosswordGroup);
      canvas2.renderAll();
    }
  });
});



// ✅ Live Scrabble build while typing
input.addEventListener("input", function () {
  const raw = input.value || "";
  const text = normalizeName(raw);

  errorMsg.style.display = "none";

  // allow spaces + A–Z only
  if (!isNameValid(text)) {
    errorMsg.textContent = "Only letters (A–Z) and spaces are allowed.";
    errorMsg.style.display = "block";
    return;
  }

  nameText = text;
  nameCount.innerText = text.trim() ? "1/1" : "0/1";
  renderNameScrabble();
});



// ✅ Render single name (width-wise only)
function renderNameScrabble() {
  if (!nameText) return;

  // Remove any previous
  if (crosswordGroup) {
    canvas2.remove(crosswordGroup);
    crosswordGroup = null;
  }

  const letters = nameText.split("");
  const usedCols = letters.length;

  // Fit horizontally
  const totalGaps = (usedCols - 1) * gapDefault;
  const tile = Math.max(
    tileMin,
    Math.min(tileMax, Math.floor((areaWidth - totalGaps) / usedCols))
  );

  const groupLeft = 700;
  const groupTop = 1570; // bottom

  const objs = [];
  let currentLeft = 0;

  let currentX = 0;

letters.forEach((letter, i) => {
  // ✅ Custom space width multiplier
  const spaceMultiplier = 0.3; // 1 = same as tile, 0.3 = 60% of tile width

  if (letter === " ") {
    // just add space width without a tile
    currentX += tile * spaceMultiplier + gapDefault * 2; // extra gap between words
    return;
  }

  // Create rect
  const rect = new fabric.Rect({
    left: currentX,
    top: 0,
    width: tile,
    height: tile,
    rx: Math.max(4, Math.round(tile * 0.08)),
    ry: Math.max(4, Math.round(tile * 0.08)),
    strokeWidth: Math.max(1, Math.round(tile * 0.04)),
    selectable: false,
    originX: "left",
    originY: "top",
    fill: "#f7e2b0",
  });

  // ✅ Proper texture fill
  if (textureImg) {
    const patternCanvas = document.createElement("canvas");
    patternCanvas.width = tile;
    patternCanvas.height = tile;
    const ctx = patternCanvas.getContext("2d");

    const texEl = textureImg.getElement ? textureImg.getElement() : textureImg._element;

    if (texEl) {
      ctx.drawImage(
        texEl,
        0,
        0,
        texEl.naturalWidth || textureImg.width,
        texEl.naturalHeight || textureImg.height,
        0,
        0,
        tile,
        tile
      );
      rect.set("fill", new fabric.Pattern({ source: patternCanvas, repeat: "no-repeat" }));
    }
  }

  // text in tile
  const txt = new fabric.Text(letter, {
    left: currentX + tile / 2,
    top: tile / 2,
    originX: "center",
    originY: "center",
    fontSize: Math.max(12, Math.round(tile * 0.62)),
    fontFamily: "Markazi Text",
    fontWeight: "bold",
    selectable: false,
    fill: "#3c2701",
  });

  objs.push(rect, txt);

  // move X to next position
  currentX += tile + gapDefault;
});


  crosswordGroup = new fabric.Group(objs, {
    left: groupLeft,
    top: groupTop,
    selectable: false,
  });

  canvas2.add(crosswordGroup);

  try {
    if (baseImage) canvas2.sendToBack(baseImage);
  } catch (e) {}

  canvas2.renderAll();
}





function canvasMakeImg(canvas,zoom){
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function canvasBlock(canvas){
  zoom = jQuery('.product__media-outer').width();
  newZoomLevel = zoom / cWidth;
  setZoomMask(canvas,newZoomLevel);
}

function setZoomMask(canvas,newZoomLevel){
  canvas.setZoom(newZoomLevel);
  canvas.setDimensions({
    width:  cWidth * newZoomLevel,
    height:  cHeight * newZoomLevel
  });
  canvas.renderAll();
}

function addModify(canvas){
  fabric.Object.prototype.transparentCorners = false;
  fabric.textureSize = 75497472;

  canvas.renderOnAddRemove = false;
  canvas.on('selection:cleared', function(e){
    object = e.target;
  });

  canvas.on('object:removed',function(e){
    object = e.target;
  });

  canvas.on('object:added', function(e){
    object = e.target;
    addControls(object);
    canvas.renderAll();
  });
  
  canvas.on('object:modified', function(e){
    object = e.target;
    canvas.renderAll();
  });
  
  canvas.on('selection:created', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('selection:updated', function(e){
    object = canvas.getActiveObject();
  });
  
  canvas.on('object:scaling', function(e){
    canvas.renderAll();
  });

  // jQuery(window).on('load',function(){
  //   canvasBlock(canvas);
  //   loadFirstImg();
  // });

  jQuery(window).on('resize',function(){
    canvasBlock(canvas);
  });
}

function addControls(object){
  var iconTL = document.createElement("img"),
      iconBR = document.createElement("img");
  
  iconTL.src = trashIcon;
  iconBR.src = resizeIcon;
  
  object.set({
    selectable:false,
    originX:"center",
    originY:"center",
    transparentCorners: false,
    borderColor: '#ddd',
    borderDashArray: [6,2],
    cornerStyle: 'circle',
    cornerColor: '#fff',
    objectCaching: false,
    _controlsVisibility: {
      tr: false,
      tl: true,
      bl: false,
      br: true,
      mb: false,
      ml: false,
      mr: false,
      mt: false,
      mtr: false
    }
  });
  
  iconTL.onload = function() {
    fabric.Object.prototype.controls.tl = new fabric.Control({
      x: -0.5,
      y: -0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "pointer",
      mouseUpHandler: deleteHandler,
      render: renderIcon(iconTL),
      withConnection: true,
      cornerSize: 18,
    });
  };
  iconBR.onload = function() {
    fabric.Object.prototype.controls.br = new fabric.Control({
      x: 0.5,
      y: 0.5,
      offsetX: 0,
      offsetY: 0,
      cursorStyle: "se-resize",
      mouseUpHandler:fabric.controlsUtils.scalingEqually,
      render: renderIcon(iconBR),
      withConnection: true,
      cornerSize: 18,
    });
  }
}

function renderIcon(icon) {
  return function (ctx, left, top, styleOverride, fabricObject) {
    const size = this.cornerSize;
    ctx.save();
    ctx.translate(left, top);
    ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
    ctx.drawImage(icon, -size / 2, -size / 2, size, size);
    ctx.restore();
  };
}

function deleteHandler(eventData,transform){
  var target = transform.target;
  activeOb = canvas.getActiveObject();
  canvas.remove(activeOb);
  canvas.renderAll();
}

initCropper();

function readURL2(input,bImg){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  if(cropper == ""){
  }else {
    cropper.destroy();
  }
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = function (e) {
      jQuery('#blah').attr('src', e.target.result);
      reCroper.attr('data-img',e.target.result);
      jQuery(bImg).val(e.target.result);
    };
    reader.readAsDataURL(input.files[0]);
    setTimeout(initCropper, 2500);
  }
}

function addImage(e,placeholderimg,canvas){
  var file = e.target.files[0];
  var reader = new FileReader();
  reader.onload = function(event){
    var imgObj = new Image();
    imgObj.src = event.target.result;
    imgObj.onload = function(){
      if (window.currentMainImage) {
        canvas.remove(window.currentMainImage);
      }
      var img = new fabric.Image(imgObj);
      img.set({
        left: placeholderimg.left,
        top: placeholderimg.top,
        selectable:true,
        scaleX: placeholderimg.width / img.width,
        scaleY: placeholderimg.height / img.height,
      });
      canvas.add(img);
      window.currentMainImage = img;
      crosswordGroup.bringToFront();
    };
  };
  reader.readAsDataURL(file);
}

function addCroppedImg(imgurl){
  canvas.remove(img).renderAll();
  if (window.currentMainImage) {
    canvas.remove(window.currentMainImage);
  }
  fabric.Image.fromURL(imgurl, function(newImg){
    newImg.set({
      left: img.left,
      top: img.top,
      selectable: img.selectable
    });
    newImg.scaleToHeight(available_height);
    canvas.add(newImg).renderAll();
    window.currentMainImage = newImg;
    crosswordGroup.bringToFront();
    canvas.renderAll();
  });
}

function initCropper(){
  var image = document.getElementById('blah');
  cropper = new Cropper(image, {
    viewMode: 1,
    dragMode: 'move',
    aspectRatio: sizeCrop,
    restore: false,
    guides: false,
    center: true,
    highlight: true,
    cropBoxMovable: true,
    cropBoxResizable: true,
    toggleDragModeOnDblclick: false,
    data:{}
  });
  jQuery('.popupImg').show();
  jQuery('#tadaWidget').addClass('hidden');
  loader.addClass('hidden');
}

document.getElementById('crop_button').addEventListener('click', function(){
  loader.removeClass('hidden');
  jQuery('#tadaWidget').addClass('hidden');
  var imgurl =  cropper.getCroppedCanvas().toDataURL();
  jQuery(this).attr('data-cropped',imgurl);
  addCroppedImg(imgurl);
  setTimeout(function(){
    reCroper.parent().removeClass('hidden');
    jQuery('.popupImg').hide();
    loader.addClass('hidden');
    jQuery('#tadaWidget').removeClass('hidden');
  },500);
});

document.getElementById('zoom_out').addEventListener('click', function(){
  cropper.zoom(-0.1);
});

document.getElementById('zoom_in').addEventListener('click', function(){
  cropper.zoom(0.1);
});

document.getElementById('reset_button').addEventListener('click', function(){
  cropper.reset();
});

document.getElementById('cancelCropper').addEventListener('click', function(){
  jQuery('.popupImg').hide();
  jQuery('#tadaWidget').removeClass('hidden');
});

jQuery(document).on('click','.btnReCrop', function(){
  loader.removeClass('hidden');
  imgurl = jQuery(this).attr('data-img');
  sizeCrop = jQuery(this).attr('data-ratio');
  img = window[jQuery(this).attr('data-obj')];
  canvas = window[jQuery(this).attr('data-canvas')];
  available_height = jQuery(this).attr('data-height');
  console.log(canvas);
  jQuery('#tadaWidget').addClass('hidden');
  setTimeout(function(){
    cropper.destroy();
    jQuery('#blah').attr('src',imgurl);
    initCropper();
    jQuery('.popupImg').show();
    loader.addClass('hidden');
  },150);
});

jQuery('.customColors').each(function(){
  colorBox = jQuery(this).attr('id');
  loadColorPicker(colorBox);
});

jQuery(document).on('click','.dropper-eyedrop',function(){
  const eyeDropper = new EyeDropper();
  eyeDropper.open().then(result => {
    jQuery(this).parent().parent().parent().colorpicker('setValue', result.sRGBHex);
  }).catch(e => {
    console.error(e);
  });
});



async function handleUpload(fileInputs,timeID){
  const temp_images = [];
  
  for (let input of fileInputs){
    const file = input.files[0]; // Only first file per input
    const croppedURL = jQuery(input).attr('data-cropped');
    if(croppedURL != ''){
      temp_images.push(croppedURL);
    }
    if(file){
      const base64 = await toBase64(file); // ✅ now safely inside async
      temp_images.push(base64);
    }
  }
  if(temp_images.length === 0){
    alert("Please select at least one image.");
    return;
  }
  const payload = {
    timeId: timeID,
    temp_images: temp_images
  };
  console.log(payload);
  try {
    const response = await fetch('//technology-architects.com/tasweer-modules/upload_client_img.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });
    
    const result = await response.json();
    console.log("Upload result:", result);
    var int = 1, wall = 1, upCrop;
    result.uploaded_images.forEach(img => {
      if(jQuery('#image'+int).length < 1){
        if (int % 2 === 0) {
          upCrop = 'User Uploaded ';
        }else{
          upCrop = 'Cropped ';
        }
        jQuery('#preview').append('<input type="hidden" id="image'+int+'" name="properties['+ upCrop + wall+']">');
        if(upCrop == 'User Uploaded '){
          wall += 1;
        }
      }
      if (img.status === "success") {
        jQuery('#image'+int).val(img.image_url);
        int += 1;
      } else {
        console.warn("Upload failed:", img.error);
      }
    });
    jQuery('.product-form__buttons .product-form__submit').trigger('click');
    loader.addClass('hidden');
  } catch (error) {
    console.error("Upload error:", error);
    alert("Upload failed.");
  }
}

// ✅ Convert a file to base64 string
function toBase64(file){
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}


/* fetch Call */
// var size,thumbnail;
var loadedObject,tagValue,Texture,additionalInfo,frameColor, wMark,svgMrk;
let pdfData = {};
jQuery(document).on('click','#download',function(){
  loader.removeClass('hidden');
  setTimeout(function(){
    resizeObjects(window['canvas2']);
    const id = ['canvas2'];
    const canvas = window['canvas2'];
    size = 350;
    loadMark(id,canvas,size);
    size = 4000;
    removeMark(canvas,size);
    canvas.remove(baseImage);
    window['canvas2'] = canvas.toDataURL('image/png');
    tagValue = jQuery('#tagInputBox input').val();
    Texture = jQuery('#shape_design img.active').attr('value');
    additionalInfo = jQuery('.tShirtImg textarea').val();
    frameColor = jQuery('.frameColorBox').val();
    canvasBlock(canvas);
    console.log(window['canvas2']);
    fetch('//technology-architects.com/tasweer-modules/save_order.php',{
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body:  JSON.stringify({
        temp_image: window['canvas2t'],
        original_image: window['canvas2']
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      var previewId = data[0],
          extraImg1 = data[1];
      jQuery('#previewImg').val(previewId);
      jQuery('#preExtraImg').val(extraImg1);
      jQuery('#tagValue').val(tagValue);
      jQuery('#Texture').val(Texture);
      jQuery('#addInfo').val(additionalInfo);
      jQuery('#selected_frameColor').val(frameColor);
      //console.log('Server response:', data);
      const fileInputs = document.querySelectorAll('.upload_image input[type="file"]');
      handleUpload(fileInputs,previewId);
    })
    .catch(error => console.error('Error uploading images:', error));
  },100);
});



function resizeObjects(canvas) {
  if (window['placeholderimg1']) window['placeholderimg1'].setCoords();
  if (typeof crosswordGroup !== 'undefined') crosswordGroup.setCoords();
  if (typeof img !== 'undefined') img.setCoords();
  if (typeof newImg !== 'undefined') newImg.setCoords();

  canvas.renderAll();

  // ✅ Include uploaded image correctly
  var designResiz = new fabric.Group([
    window['placeholderimg1'],
    crosswordGroup,
    window.currentMainImage, // main uploaded image
  ].filter(Boolean));

  designResiz.set({
    left: halfWidth,
    top: halfHeight,
    originX: 'center',
    originY: 'center'
  });

  // ✅ Scale whole group to desired width
  designResiz.scaleToWidth(1150);
  designResiz.setCoords();

  canvas.renderAll();
}




function loadMark(id,canvas,size){
  wMark = document.getElementById('wm_collage');
  svgMrk = wMark.innerHTML;
  fabric.loadSVGFromString(svgMrk, function(objects,options){
    loadedObject = fabric.util.groupSVGElements(objects, options);
    loadedObject.scaleToWidth(cWidth);
    loadedObject.set({
      left: cWidth / 2,
      top: cHeight / 2,
      originX: 'center',
      originY: 'center',
      objectCaching: false,
      selectable: false
    });
    canvas.add(loadedObject);
    loadedObject.bringToFront();
    loadedObject.setCoords();
    canvas.remove(baseImage);
    canvas.renderAll();
  });
  canvasMakeImg(canvas,size);
  window[id+'t'] = canvas.toDataURL('image/png');
  console.log(window[id+'t']);
}

function removeMark(canvas,size){
  canvas.remove(loadedObject).renderAll();
  canvasMakeImg(canvas,size);
}